import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendarStar = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.907 9.665h16.196M15.639 3v2.962M8.367 3v2.962M20.1 11.624V8.6c.007-2.707-1.636-4.18-4.287-4.18H8.192c-2.644 0-4.295 1.473-4.295 4.18v8.146c0 2.749 1.65 4.255 4.295 4.255h2.218M7.956 13.282zM11.634 13.282zM7.956 16.673z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.524 13.86.797 1.596a.54.54 0 0 0 .406.29l1.786.257a.53.53 0 0 1 .298.906l-1.292 1.24a.53.53 0 0 0-.155.47l.306 1.753a.537.537 0 0 1-.781.559l-1.595-.828a.55.55 0 0 0-.502 0l-1.596.828a.537.537 0 0 1-.78-.56l.304-1.752a.52.52 0 0 0-.154-.47l-1.293-1.24a.53.53 0 0 1 .298-.905l1.786-.258a.54.54 0 0 0 .405-.29l.8-1.596a.543.543 0 0 1 .962 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalendarStar);
export default ForwardRef;
